/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Console_Input_TabInputs */

const en_console_input_tab = /** @type {(inputs: Console_Input_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input`)
};

const zh_hans1_console_input_tab = /** @type {(inputs: Console_Input_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入`)
};

const pt_br2_console_input_tab = /** @type {(inputs: Console_Input_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada`)
};

const es_console_input_tab = /** @type {(inputs: Console_Input_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada`)
};

const fr_console_input_tab = /** @type {(inputs: Console_Input_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrée`)
};

const de_console_input_tab = /** @type {(inputs: Console_Input_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingabe`)
};

const ru_console_input_tab = /** @type {(inputs: Console_Input_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ввод`)
};

const it_console_input_tab = /** @type {(inputs: Console_Input_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input`)
};

/**
* | output |
* | --- |
* | "Input" |
*
* @param {Console_Input_TabInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const console_input_tab = /** @type {((inputs?: Console_Input_TabInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Input_TabInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_console_input_tab(inputs)
	if (locale === "pt-BR") return pt_br2_console_input_tab(inputs)
	if (locale === "es") return es_console_input_tab(inputs)
	if (locale === "fr") return fr_console_input_tab(inputs)
	if (locale === "de") return de_console_input_tab(inputs)
	if (locale === "ru") return ru_console_input_tab(inputs)
	if (locale === "it") return it_console_input_tab(inputs)
	return en_console_input_tab(inputs)
});